module.exports = __webpack_public_path__ + "img/gh_pic06-cff725.png";